import { render, staticRenderFns } from "./DeficientesCard.vue?vue&type=template&id=aa22c3f0&scoped=true"
import script from "./DeficientesCard.vue?vue&type=script&lang=js"
export * from "./DeficientesCard.vue?vue&type=script&lang=js"
import style0 from "./DeficientesCard.vue?vue&type=style&index=0&id=aa22c3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa22c3f0",
  null
  
)

export default component.exports